<template lang="pug">

    tbody

        //- View
        tr
            td.seven.wide
                strong Kampagne
            td.seven.wide {{ viewValue | truncate(16) }}
            td.two.wide.right.aligned

                a(v-if="$route.name !== 'quality-rating'" v-on:click='showModal()')
                    i.edit.icon

                modal(ref='modal')

                    //- Header
                    span(slot="header") Kampagne bearbeiten

                    //- Form
                    .ui.form(slot="content")
                        campaign-dropdown-field(
                            v-bind:companyModel='companyModel'
                            v-bind:campaignModels='campaignModels'
                            v-model='model'
                        )

                    //- Actions
                    div(slot="footer")
                        .ui.column.grid
                            .right.aligned.column
                                a.ui.labeled.icon.button(v-on:click='cancel()')
                                    i.remove.icon
                                    |  Abbrechen
                                button.ui.labeled.primary.icon.button(type='submit' v-on:click="persist()")
                                    i.checkmark.icon
                                    |  Speichern

</template>

<script>
    import compose from 'lodash/fp/compose'
    import find from 'lodash/fp/find'
    import property from 'lodash/fp/property'
    import defaultTo from 'lodash/fp/defaultTo'
    import CampaignDropdownField from '@/components/campaigns/DropdownField.vue'
    import Modal from '@/components/app/Modal.vue'

    //noinspection ReservedWordAsName,JSUnusedGlobalSymbols
    export default {

        components: { CampaignDropdownField, Modal },

        computed: {
            viewValue() {
                return compose([
                    // Defaultwert auf `-` setzen
                    defaultTo('-'),

                    // Eigenschaft `name` lesen
                    property('name'),

                    // Kampagne suchen
                    find(campaignModel => campaignModel.id === this.productModel.campaign)
                ])(this.campaignModels)
            }
        },

        created() {
            // Kampagne des Produktes speichern
            this.model = this.productModel.campaign
        },

        data() {
            return {
                model: undefined,
            }
        },

        methods: {

            cancel() {
                this.$refs.modal.close()
            },

            persist() {
                // Payload erstellen
                const model = { ...this.productModel, campaign: this.model }

                // Speichern
                this.$store.dispatch('products/update', { id: model.id, model }).then(() => {
                    this.$refs.modal.close()
                    this.$growl.success('Kampagne wurde gespeichert')
                }).catch(e => {
                    this.$growl.fatal('Kampagne konnte nicht gespeichert werden. Bitte den Support kontaktieren', e)
                })
            },

            showModal() {
                this.$refs.modal.show()
            }
        },

        props: {
            campaignModels: {
                type: Array,
                required: true
            },
            companyModel: {
                type: Object,
                required: true
            },
            productModel: {
                type: Object,
                required: true
            }
        },

        watch: {
            'productModel.campaign'(value) {
                this.campaign = value
            }
        }

    }

</script>
